export default __webpack_public_path__ + "static/media/work.901f93e7.jpg";